// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"b2c767d0","553":"24eb812a","963":"e9cb961c"}[chunkId] + ".chunk.js";
};